import React, { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import "toastr/build/toastr.min.css";
import DateUtils from "../../../../../services/utils/DateUtils";
import axios from "axios";
import {
    API_URL_GET_REPORT_LIST
} from '../../../constants';
import { GDPR_REPORT_STATUS_LIST } from "src/modules/data-protection/constants/Common";
import {
    INTERNATIONAL_DATE_FORMAT,
} from "../../../../../common/constants";
import SecurityBreachImage from "src/modules/data-protection/assets/images/security-breach.png";
import DataDeletionImage from "src/modules/data-protection/assets/images/data-deletion.png";
import OtherRequests from "src/modules/data-protection/assets/images/OtherRequests.png";
import { setCaseId } from "../../../../../store/actions";
import { displayedCaseReference } from "src/helpers/case_reference_helper";
import { withRouter } from "react-router-dom";
import { EMPTY_LIST } from "../../../../../common/constants";
import BootstrapTable from "react-bootstrap-table-next";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Navigator from "src/components/Navigator";
import FilteringComponent from "./filtering-component";

const MyReportList = ({
    t,
    onSetCaseId,
    token
}) => {
    const [tableFilters, setTableFilters] = useState({
        pageIndex: 1,
        pageSize: 25,
        status: null,
        category: null
    });

    const dateUtils = new DateUtils();

    const handleRenderReportTypeIcon = (type) => {
        switch (type?.toLowerCase()) {
            case "data breach incident": {
                return (
                    <div className="d-flex align-items-center">
                        <img
                            style={{ width: "24px", height: "24px", marginRight: 9 }}
                            alt={type}
                            className="rounded-circle card-img"
                            src={SecurityBreachImage}
                        />
                        <span style={{ textTransform: "capitalize" }}>{t(type)}</span>
                    </div>
                );
            }
            case "data deletion request": {
                return (
                    <div className="d-flex align-items-center">
                        <img
                            style={{ width: "24px", height: "24px", marginRight: 9 }}
                            alt={type}
                            className="rounded-circle card-img"
                            src={DataDeletionImage}
                        />
                        <span style={{ textTransform: "capitalize" }}>{t(type)}</span>
                    </div>
                );
            }
            case "data subject request": {
                return (
                    <div className="d-flex align-items-center">
                        <img
                            style={{ width: "24px", height: "24px", marginRight: 9 }}
                            alt={type}
                            className="rounded-circle card-img"
                            src={OtherRequests}
                        />
                        <span style={{ textTransform: "capitalize" }}>{t(type)}</span>
                    </div>
                );
            }
            default: {
                return (
                    <div className="d-flex align-items-center">
                        <span style={{ textTransform: "capitalize" }}>{type}</span>
                    </div>
                );
            }
        }
    };

    const handleReportLink = (type, id) => {
        let link = "";
        switch (type?.toLowerCase()) {
            case "data subject request":
                link = `/employee/data-protection/data-subject-request/details/${id}`
                break;
            case "data breach incident":
                link = `/employee/data-protection/incident-register/details/${id}`
                break;
            default: 
                link = "#";
                break;
        }
        return link;
    }

    const handleRenderReportStatus = (statusId) => {
        const newStatus = GDPR_REPORT_STATUS_LIST.find(
            (item) => item.id === statusId
        );

        return (
            <div
                style={{
                    fontWeight: 600,
                    padding: "6px 10px",
                    background: newStatus?.backgroundColor,
                    opacity: newStatus?.opacity || 1,
                    color: "#1D1D1D",
                    borderRadius: '7px',
                    whiteSpace: 'nowrap',
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)"
                }}
                className={"dt-task-status "}
            >
                {t(newStatus?.titleKey)}
            </div>
        );
    };

    const handleRenderReportCategories = (reportCategories) => {
        return reportCategories?.join(", ");
    };

    const tableColumns = [
        {
            dataField: "type",
            text: t("Type"),
            sort: false,
            key: 2,
            formatter: (cellContent, row) => {
                return (
                    <Link
                        className="text-dark"
                        to={handleReportLink(row.questionnaire, row.case_id)}
                        onClick={() => {
                            onSetCaseId(row.case_id);
                            localStorage.setItem("caseId", row.case_id);
                        }}
                    >
                        {handleRenderReportTypeIcon(row.questionnaire)}
                    </Link>
                );
            },
            headerStyle: {
                width: "220px"
            },
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                verticalAlign: "middle",
            }
        },
        {
            dataField: "case_id",
            text: t("Case ID"),
            sort: false,
            headerStyle: { maxWidth: "200px" },
            key: 3,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                return (
                    <Link
                        className="text-dark"
                        to={handleReportLink(row.questionnaire, row.case_id)}
                        onClick={() => {
                            onSetCaseId(row.case_id);
                            localStorage.setItem("caseId", row.case_id);
                        }}
                    >
                        {displayedCaseReference(row)}
                    </Link>
                );
            },
        },
        {
            dataField: "description",
            text: t("Description"),
            sort: false,
            key: 4,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                return <div>{row.description ? (row.description.length > 70 ? `${row.description.substring(0, 70)}...` : row.description) : ''}</div>;
            },
        },
        {
            dataField: "category",
            text: t("Categories"),
            sort: false,
            style: {
                display: "table-cell",
                maxWidth: "600px",
                verticalAlign: "middle",
                whiteSpace: "normal"
            },
            headerStyle: {
                maxWidth: "600px",
                whiteSpace: "normal"
            },
            key: 5,
            formatter: (cellContent, row) => {
                const categoriesText = handleRenderReportCategories(row?.categories);

                return (
                    <div
                        style={{
                            maxWidth: "500px",
                            whiteSpace: "normal",
                            padding: "5px",
                        }}
                        title={categoriesText}
                    >
                        {categoriesText}
                    </div>)
            },
        },
        {
            dataField: "submission_date",
            text: t("Submission date"),
            sort: false,
            key: 6,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            cellContent,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                );
            },
        },
        {
            dataField: "closing_date",
            text: t("Closing date"),
            sort: false,
            key: 7,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            cellContent,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                );
            },
        },
        {
            dataField: "analyst_assigned",
            text: t("Assigned analyst"),
            sort: false,
            key: 8,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                if (!cellContent || Array.isArray(cellContent)) return null;
                return (
                    <div className="d-flex align-items-center gap-1"><span className='dt-list-col-bullet'>{cellContent.first_name[0]}</span>{' '}{`${cellContent.first_name} ${cellContent.last_name}`}</div>
                );
            },
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: false,
            key: 9,
            style: {
                verticalAlign: "middle"
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {handleRenderReportStatus(row.status)}
                        <div>
                            <small className="text-muted">
                                {t("Updated")}:{" "}
                                {dateUtils.convertTimeStampToDate(
                                    row.status_updating_date,
                                    INTERNATIONAL_DATE_FORMAT
                                )}
                            </small>
                        </div>
                    </div>
                );
            },
        },
    ];

    const NoDataIndication = () =>
        handleFetchReportListQuery.isFetched &&
            !handleFetchReportListQuery.length ? (
            <div className="alert m-0" role="alert">
                <p
                    style={{
                        textAlign: "center",
                        marginBottom: 0,
                    }}
                >
                    {t(EMPTY_LIST)}
                </p>
            </div>
        ) : (
            <></>
        );

    const handleFetchReportListQuery = useQuery({
        queryKey: [
            "gdpr-fetch-my-reports-query", 
            tableFilters
        ],
        queryFn: async () => {
            const response = await axios.post(`${API_URL_GET_REPORT_LIST}`, tableFilters, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });

            return response.data?.data || [];
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching report list."), {
                type: "error"
            });
        }
    });

    const handleTableChange = (type, { page, sizePerPage }) => {
        switch (type) {
            case "pagination":
                setTableFilters({
                    ...tableFilters,
                    pageIndex: page,
                    pageSize: sizePerPage,
                });
                break;
            default:
                return false;
        }
    };

    const handleFilterChange = useCallback((newFilters) => {
        setTableFilters((prevFilters) => ({...prevFilters, ...newFilters}));
    }, []);

    return (
        <div className="page-content">
            <Container fluid style={{ minHeight: "400px" }}>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle="My reports"
                            breadCrumbs={[
                                { title: "SIP", link: "/employee/home?landing=false" },
                                {
                                    title: "My reports",
                                    link: `#`
                                }
                            ]}
                        />
                    </Col>

                    <Col lg="12">
                        <div
                            className="bg-white"
                            style={{
                                borderRadius: "7px",
                                boxShadow: "0px 0px 4px 0px #4F666E40",
                            }}
                        >
                            <div className="p-4" style={{ marginBottom: "300px" }}>
                                <PaginationProvider
                                    pagination={paginationFactory({
                                        custom: true,
                                        page: tableFilters.pageIndex,
                                        sizePerPage: tableFilters.pageSize,
                                        totalSize: handleFetchReportListQuery.data?.itemsCount || 0,
                                        withFirstAndLast: false,
                                        alwaysShowAllBtns: true,
                                        prePageText: (
                                            <span>
                                                <i className="ri-arrow-left-s-line"></i>{" "}
                                                {t("Back")}
                                            </span>
                                        ),
                                        nextPageText: (
                                            <span>
                                                {t("Next")}{" "}
                                                <i className="ri-arrow-right-s-line"></i>
                                            </span>
                                        ),
                                        prePageTitle: t("Pre page"),
                                        firstPageTitle: t("Next page"),
                                        showTotal: true,
                                        hideSizePerPage: false,
                                        sizePerPageList: [
                                            {
                                                text: "25",
                                                value: 25,
                                            },
                                            {
                                                text: "50",
                                                value: 50,
                                            },
                                        ],
                                    })}
                                >
                                    {({ paginationProps, paginationTableProps }) => (
                                        <React.Fragment>
                                            <Row className="mb-5 mt-3">
                                                <Col sm="12">
                                                    <div className="d-flex gap-2 justify-content-end">
                                                        <FilteringComponent 
                                                            onChange={handleFilterChange}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <BootstrapTable
                                                        remote={{
                                                            pagination: true,
                                                            filter: false,
                                                            sort: true,
                                                            cellEdit: false,
                                                            search: false,
                                                        }}
                                                        loading={
                                                            handleFetchReportListQuery.isFetching ||
                                                            handleFetchReportListQuery.isLoading
                                                        }
                                                        overlay={overlayFactory({
                                                            spinner: (
                                                                <Spinner
                                                                    animation="border"
                                                                    variant="primary"
                                                                    size="md"
                                                                />
                                                            ),
                                                            text: "Loading...",
                                                        })}
                                                        onTableChange={handleTableChange}
                                                        defaultSorted={[]}
                                                        keyField={"id"}
                                                        responsive
                                                        bordered={false}
                                                        data={handleFetchReportListQuery.data?.reports || []}
                                                        striped={true}
                                                        columns={tableColumns}
                                                        wrapperClasses="table-responsive"
                                                        classes={"table tpdd-table incident-table tp-reports-table"}
                                                        headerWrapperClasses={"thead-light"}
                                                        style={{
                                                            overflowX: "auto",
                                                        }}
                                                        noDataIndication={() => <NoDataIndication />}
                                                        {...paginationTableProps}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm="12" md="6">
                                                    <div className="tpdd-pagination-style-1">
                                                        <PaginationListStandalone {...paginationProps} />

                                                        <SizePerPageDropdownStandalone
                                                            {...paginationProps}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    )}
                                </PaginationProvider>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return { token };
};

const mapDispatchToProps = (dispatch) => ({
    onSetCaseId: (caseId) => dispatch(setCaseId(caseId)),
});

export default withNamespaces()(
    withRouter(connect(mapStatetoProps, mapDispatchToProps)(MyReportList))
);
